import type { AccessGate } from '../types/access-gate.type';
import type { MissionWording } from '../../../app/utils/mission-kind-profile.util';

// The mission fields a submitted quotation freezes, told the same way on every page showing them:
// `lockedFields` reads « son adresse ne peut plus changer », `wording` names the mission after its kind.
export const quotationLockMessage = (
  gate: AccessGate,
  lockedFields: string,
  wording: MissionWording,
): string | null =>
  gate.isAllowed || !gate.reasons.length
    ? null
    : `Le devis ${wording.ofName} est soumis : ${lockedFields}.`;
